module.exports = __webpack_public_path__ + "img/dab45fddb432d4db0a6403b041c2f62d.d7385c6e.png";